import RadioButton from '../../../../../components/RadioButton';
import { useProctoring } from '../../../../../hooks/useProctoring';
import { HelpIcon } from '../../../../../assets/icons/common';
import Button from '../../../../../components/Button';
import { questionHelp } from '../../../../../config/exam';
import { NO_ANSWER, PROCTORING_TYPE } from '../../constants';
import { MouseEvent, useState } from 'react';
import { CurrentQuestion } from '../../types';
import QuestionText from '../QuestionText';
import styles from './style.module.scss';

interface Props {
    counter: number;
    loading: boolean;
    canSkip: boolean;
    jobTitle?: string;
    onNext: () => void;
    onSkip: () => void;
    userId: string | null;
    selectedOption: number;
    question: CurrentQuestion;
    onSelectOption: (index: number) => void;
};

function ExamBox(props: Props) {
    const {
        counter,
        loading,
        canSkip,
        onNext,
        onSkip,
        userId,
        question,
        jobTitle,
        selectedOption,
        onSelectOption,
    } = props;

    const [showHelp, setShowHelp] = useState(false);
    const isTimedOut = counter === 0;

    useProctoring(userId, question.examId, question.number, PROCTORING_TYPE);

    const toggleHelp = (e: MouseEvent<SVGSVGElement>) => {
        e.stopPropagation();
        setShowHelp(prev => !prev);
    };

    const reportProblem = () => {
        setShowHelp(false);
        onSkip();
    };

    return (
        <div className={styles.wrapper} onClick={() => setShowHelp(false)}>
            <div className={styles.content} data-time-out={isTimedOut}>
                <div className={styles.header}>
                    <span className={styles.question_count}>
                        {`${question.number} / ${question.total}`}
                    </span>
                    <span className={styles.job_title}>{jobTitle}</span>
                    <div className={styles.help}>
                        <HelpIcon onClick={toggleHelp} />
                        {showHelp && <div className={styles.help_list}>
                            {questionHelp.map(item =>
                                <span key={item} onClick={reportProblem}>{item}</span>)}
                        </div>}
                    </div>
                </div>
                <QuestionText number={question.number} text={question.text} />
                <div className={styles.options}>
                    {question.options.map((option, index) =>
                        <RadioButton
                            key={index}
                            text={option}
                            disabled={isTimedOut}
                            checked={selectedOption === index}
                            setChecked={() => onSelectOption(index)}
                            radioClassName={isTimedOut ? styles.timeOutRadio : ''}
                        />)}
                </div>
            </div>
            <Button
                onClick={onNext}
                loading={loading}
                className={styles.CTA}
                type={(question.isLast || isTimedOut) ? 'Error' : 'Primary'}
                disabled={!canSkip && !isTimedOut && selectedOption === NO_ANSWER}
                text={question.isLast ? 'End exam' : isTimedOut ? 'Time out' : 'Next question'}
            />
        </div>
    )
};

export default ExamBox;
